
export default function GenerateHashId() {
  const timestamp = Math.floor(new Date().getTime() / 1000).toString(16).padStart(8, '0');

  let randomPart = '';
  for (let i = 0; i < 16; i++) {
    randomPart += Math.floor(Math.random() * 16).toString(16);
  }

  return timestamp + randomPart;
}